import React, { useEffect, useRef } from 'react';

function VideoItem({ videoUrl, showVideo }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current && videoUrl) {
      videoRef.current.load();
    }
  }, [videoUrl]);

  if (!showVideo || !videoUrl) return null;

  return (
    <div className="video-player-container">
      <h4 style={{ marginBottom: '10px', color: '#D9C524' }}>Video Player</h4>
      <video
        ref={videoRef}
        controls
        preload="metadata"
        width="100%"
        style={{
          borderRadius: '8px',
          boxShadow: '0 4px 15px rgba(217, 197, 36, 0.2)',
          backgroundColor: '#000'
        }}
        onContextMenu={(e) => e.preventDefault()}
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <p style={{ fontSize: '11px', color: '#D9D9D9', marginTop: '8px', fontStyle: 'italic' }}>
        * Secure stream: Unauthorized downloading is disabled.
      </p>
    </div>
  );
}

export default VideoItem;